module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-latin-ext7.ccfa20f.woff2";